import React from 'react';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { SocialProofReviews } from './components/SocialProofReviews';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusSection } from './components/BonusSection';
import { Testimonials } from './components/Testimonials';
import { PricingSection } from './components/PricingSection';
import { ComparisonTable } from './components/ComparisonTable';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Faq } from './components/Faq';
import { CostOfDelay } from './components/CostOfDelay';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { VerifiedPurchasePopup } from './components/VerifiedPurchasePopup';
export function App() {
  return <div className="w-full min-h-full bg-ink-950 text-gray-200" data-id="element-0" data-mp="23vkuadim43jn">
      <main data-id="element-1" data-mp="23t8iki3g6pf1">
        <Hero data-id="element-2" data-mp="23ti5txx3yih1" />
        <StatsBar data-id="element-3" data-mp="3ik7eyd5x05p2" />
        <SocialProofReviews data-id="element-4" data-mp="3ikqz80j1f669" />
        <ProblemSection data-id="element-5" data-mp="3ijfunyhrpue3" />
        <SolutionSection data-id="element-6" data-mp="3ii4ro0w5cqo1" />
        <BonusSection data-id="element-7" data-mp="3ml1419v3fqjj" />
        <Testimonials data-id="element-8" data-mp="3mkhnnxl3da7m" />
        <PricingSection data-id="element-9" data-mp="3mjq27fl7ksv2" />
        <ComparisonTable data-id="element-10" data-mp="3mj6lu3b7icj5" />
        <GuaranteeSection data-id="element-11" data-mp="3rbrc4uuwm7hx" />
        <Faq data-id="element-12" data-mp="3rdkh85pvcjnt" />
        <CostOfDelay data-id="element-13" data-mp="3rd1all5o5hp3" />
        <FinalCta data-id="element-14" data-mp="3relw6la09qat" />
      </main>
      <Footer data-id="element-15" data-mp="6htjo98ovic" />
      <VerifiedPurchasePopup data-id="element-16" data-mp="4wwnrzgd0hb" />
    </div>;
}